// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"bb5db12b","71":"9fe20c4c","636":"80e7b65a","700":"cfa82fc7","903":"fce9918b"}[chunkId] + ".chunk.css";
};